import * as React from "react";

function SatoshiV1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17zM8.86 8.011l7.639 2.063M13.089 7.27l.406-1.774M10.503 18.504l.408-1.773M8.18 10.969l7.636 2.066M7.5 13.925l7.638 2.064"
  }));
}

export default SatoshiV1Icon;